import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import bundleServices from "../../../../../services/buildServices/economyServices/bundleServices/bundleServices";
import { GET_BUNDLES, GET_BUNDLES_BY_ID, ADD_BUNDLES, EDIT_BUNDLES, FILTER_BUNDELS_SUCCESS, FILTER_BUNDELS_ERROR, GET_BUNDLES_SUCCESS, GET_BUNDLES_ERROR } from "../../../../actionTypes/actionTypes";
import Toast from '../../../../../components/Toast';

export const getAllBundlesAction = (body, configureSkeleton) => {
    return async (dispatch) => {
        dispatch(getAllBundles(null, null, GET_BUNDLES))
        await bundleServices.getAllBundles(body)
        .then(res=>{
            if(configureSkeleton){
                configureSkeleton()
            }
            dispatch(getAllBundles(res.data.data.bundles, (body?.showArchived ? res.data.data.archiveCount : res.data.data.totalCount), (body?.showArchived ? FILTER_BUNDELS_SUCCESS : GET_BUNDLES_SUCCESS)))
        }).catch(err=>{
            dispatch(getAllBundles(err.response, null,  (body?.showArchived ? FILTER_BUNDELS_SUCCESS : GET_BUNDLES_ERROR)))
        })
    }
}

export const filterBundlesAction = (body, configureSkeleton, isFiltered) => {
    return async (dispatch) => {
        await bundleServices.getAllBundles(body)
        .then(res => {
            if(configureSkeleton){
                configureSkeleton()
            }
            dispatch(filteredBundles(res.data.data.bundles, ((body?.search && body?.search !== '') ? res.data.data.searchCount : (body?.search === undefined && isFiltered) ? res.data.data.filterCount : res.data.data.totalCount), FILTER_BUNDELS_SUCCESS))
        }).catch(err=>{
            dispatch(filteredBundles(err.response, null, FILTER_BUNDELS_ERROR))
        })
    }
}

export const getCurrencyByIdAction = (body) => {
    return async (dispatch) => {
        await bundleServices.getBundleById(body)
        .then(res=>{
            dispatch(getBundleById(res.data.data.bundles))
        }).catch(err=>{
            console.log(err)
        })
    }
}

export const createBundleAction = (body, navigate, appid, setDisable) => {
    return async (dispatch) => {
        if(setDisable){
            setDisable(true)
        }
        await bundleServices.addBundle(body)
        .then(res=>{
            toast.success(<Toast type='Success' messages={res.data.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            setTimeout(()=>{
                if(setDisable){
                    setDisable(false)
                }
                if(navigate){
                    navigate(`/bundle/${appid}`)
                }
            }, 2000)
            return res;
        }).catch(error => {
            if(setDisable){
                setDisable(false)
            }
            error.response.data.errors && error.response.data.errors.map((err,i)=>{
                toast.error(<Toast type='Error' messages={err.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            })
            throw error;
        })
    }
}

export const editBundleAction = (body, navigate, appid, setDisable) => {
    return async (dispatch) => {
        if(setDisable){
            setDisable(true)
        }
        await bundleServices.editBundle(body)
        .then(res=>{
            toast.success(<Toast type='Success' messages={res.data.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            setTimeout(()=>{
                if(setDisable){
                    setDisable(false)
                }
                if(navigate){
                    navigate(`/bundle/${appid}`)
                }
            }, 2000)
            return res;
        }).catch(error => {
            if(setDisable){
                setDisable(false)
            }
            error.response.data.errors && error.response.data.errors.map((err,i)=>{
                toast.error(<Toast type='Error' messages={err.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            })
            throw error;
        })
    }
}

export const archiveBundleAction = (body, appid, onClose, status) => {
    return async(dispatch) => {
        try {
            const res = await bundleServices.archiveBundle(body)
            if(res){
                toast.success(<Toast type='Success' messages={res.data.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
                let data = {projectId: appid, showArchived: status, sortField: "updated_at", sortOrder: "asc", offset: 0, limit: 8}
                dispatch(getAllBundlesAction(data))
                if(onClose){
                    onClose()
                }
            }
            return res;
        }catch(error) {
            error.response.data.errors && error.response.data.errors.map((err,i)=>{
                toast.error(<Toast type='Error' messages={err.message}/>, {position : 'top-center', icon: false, hideProgressBar : true, autoClose: 2000})
            })
            throw error; 
        }
    }
}

export const getAllBundles = (data, count, type) => {
    return {
        type : type,
        payload : data,
        totalCount : count
    }
}

export const getBundleById = (data) => {
    return {
        type : GET_BUNDLES_BY_ID,
        payload : data
    }
}

export const addBundle = (data) => {
    return {
        type : ADD_BUNDLES,
        payload : data
    }
}

export const editBundle = (data) => {
    return {
        type : EDIT_BUNDLES,
        payload : data
    }
}

export const filteredBundles = (data, count, type) => {
    return {
        type : type,
        payload : data,
        totalCount : count
    }
}